import {AddSchema, MGLClass} from "mobx-graphlink";

@MGLClass({table: "activities"})
export class Activity {
	constructor(initialData: Partial<Activity>) {
		this.Extend(initialData);
	}
	id: string;
	creator: string;
	//createdAt: number;

	name: string;
	color: string;
}
AddSchema("Activity", {
	properties: {
		id: {type: "string"},
		creator: {type: "string"},
		//createdAt: {type: "number"},

		name: {type: "string"},
		color: {type: "string"},
	},
});